import React, { Component } from 'react'

import HoverAvatar from 'components/shared/HoverAvatar'
import { makeDefaultFailedContainer } from 'components/container'
import UISelect from 'components/shared/UISelect'

class UserSelect extends Component {
  userRenderer(userId) {
    const { users } = this.props

    if (typeof userId === 'undefined') return
    const user = users[userId]
    return (
      <div className="flex">
        <HoverAvatar user={user} size="extra-small" style={{ marginRight: 4 }}/>
        {user.name || user.email}
      </div>
    )
  }

  renderOptionUser = value => {
    return this.userRenderer(value && value.userId)
  }

  renderValueUser = option => {
    return this.userRenderer(option[0] && option[0].userId)
  }

  render() {
    const { selectedUserId, users, onChange } = this.props
    return (
      <UISelect
        searchable={false}
        value={[{ userId: selectedUserId, isInTree: true }]}
        options={Object.keys(users).map(userId => ({ userId }))}
        optionRenderer={this.renderOptionUser}
        valueRenderer={this.renderValueUser}
        className={'full-width'}
        onChange={onChange}
      />
    )
  }
}

export default makeDefaultFailedContainer(UserSelect, {
  listenTo: ['stores.UserStore'],
  fetch: {
    users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg()
    },
  },
})



// WEBPACK FOOTER //
// ./src/scripts/components/shared/UserSelect/index.js